import { Component } from '@angular/core';
import { ContenutiCorrelatiComponent } from './contenuti-correlati/contenuti-correlati.component';
import { MultiLinkAccordionComponent } from '@app/components/multi-link-accordion/multi-link-accordion.component';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { PageContent } from '@app/models/page-content';
import { RouterService } from '@app/services/router.service';
import { Router } from '@angular/router';
import { ApiCallerService } from '@app/services/api-caller.service';
import { LoadingSpinnerComponent } from '@app/components/loading-spinner/loading-spinner.component';
import { PageErrorComponent } from '@app/components/page-error/page-error.component';

@Component({
	selector: 'app-home-view',
	standalone: true,
	imports: [
		ContenutiCorrelatiComponent,
		MultiLinkAccordionComponent,
		MainMenuComponent,
		LoadingSpinnerComponent,
		PageErrorComponent,
	],
	templateUrl: './home-view.component.html',
	styleUrl: './home-view.component.css',
})
export class HomeViewComponent {
	contentLoaded: boolean = false;
	content: PageContent = {} as PageContent;

	showPageError: boolean = false;

	constructor(
		private apiCallerService: ApiCallerService,
		private routerService: RouterService,
		private router: Router,
	) {}

	ngOnInit() {
		this.apiCallerService.getHomePageContent(
			(data: PageContent) => (this.content = data),
			() => {
				this.showPageError = true;
			},
			() => (this.contentLoaded = true),
		);

		this.routerService.setActivePage(this.router.url);
	}
}
